import { config } from '_config';
import { AxiosClient } from '../AxiosClient';

const { apiUrl } = config;

class WebhookService extends AxiosClient {
  constructor(url) {
    super(url);
    this.slack = this.slack.bind(this);
    this.ip = this.ip.bind(this);
  }

  slack({ channel, message }) {
    const path = `/webhook/slack`;
    return this.client.post(path, { channel, message });
  }

  ip() {
    const path = `/webhook/ip`;
    return this.client.get(path);
  }
}

const ServiceInstance = new WebhookService(apiUrl);

export { ServiceInstance as WebhookService };
